import {
    UPDATE_USER_PRODUCT_MEMBERSHIP,
    UPDATE_USER_PRODUCT_MEMBERSHIP_FAILURE,
    UPDATE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

export const updateUserProductMembership = (payload) => {
    return {
        type: UPDATE_USER_PRODUCT_MEMBERSHIP,
        payload,
    };
};

export const updateUserProductMembershipFailure = (error) => {
    return {
        type: UPDATE_USER_PRODUCT_MEMBERSHIP_FAILURE,
        error,
    };
};

export const updateUserProductMembershipSuccess = (payload) => {
    return {
        type: UPDATE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
        payload,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/users/product-memberships/updateUserProductMembership.js